import {Pagination, Table, Tag, Typography} from "antd";
import CustomerAction from "./CustomerAction";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {renderDate} from "../../../../utils";

const { Paragraph } = Typography;


function CustomerTable({items = [], pagination, onPaginationChange, setItemEdit, openModal, handleStatus, can}) {

	const {tableHeight} = useContext(AppContext);

	let columns = [
		{ title: 'Mã KH', dataIndex: 'code', key: "code", width: '100px', render: (_, item) => (
			<div>
				<b>{item?.code}</b>
			</div>
		)},
		{ title: 'Khách hàng', dataIndex: 'name', key: "name", width: '200px', render: (_, item) => (
			<div>
				<p>{item.name}</p>
			</div>
		)},
		{ title: 'Liên hệ', dataIndex: 'contact', key: "contact", width: '200px', render: (_, item) => (
			<div>
				<p>{item?.phone}</p>
				<p>{item?.email}</p>
			</div>
		)},
		{ title: 'Địa chỉ', dataIndex: 'address', key: "address", width: '200px', render: (_, item) => (
				<Paragraph
					ellipsis={{ rows: 2, expandable: true, symbol: 'xem thêm' }}
					style={{ margin: 0 }}
				>
					<div>
						<p>{item.address}</p>
					</div>
				</Paragraph>
		)},
		{ title: '#', dataIndex: 'action', key: "action", width: '150px', render: (_, item) => (
			<CustomerAction key={item.id}
							item={item}
							setItemEdit={setItemEdit}
							openModal={openModal}
							can={can}
			/>
		)},
	];


	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table
					columns={columns}
					dataSource={dataSource}
					scroll={{ y:tableHeight, x: 'max-content' }}
					pagination={false}
				/>
			</div>
			<Pagination current={pagination?.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination?.limit} total={pagination?.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default CustomerTable;